import { z } from 'zod'

export const AppSchema = z.object({
  name: z.string(),
  label: z.string(),
  app_url: z.string(),
  game_id_type: z.string().nullable(),
  disabled: z.boolean(),
  params: z.any().nullable(),
  is_default: z.boolean(),
  updated_at: z.string(),
  icon_url: z.string(),
  id: z.number(),
  spectator_url: z.string(),
  status: z.enum(['DEV', 'PRD', 'COMING SOON']),
  is_active: z.boolean(),
  sort_order: z.number(),
  created_at: z.string(),
  disabled_reason: z.string(),
})

export type AppType = z.infer<typeof AppSchema>
